var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8671 14.8005C11.0671 13.9672 8.93375 13.9672 7.13375 14.8005C6.70042 15.0005 7.23376 16.2005 7.70042 15.9672C8.90042 15.4005 10.6671 15.2005 12.3338 15.9672C12.7671 16.1672 13.3338 15.0339 12.8671 14.8005Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3345 9.66675C17.3345 11.3334 16.0011 12.6667 14.3345 12.6667C12.6678 12.6667 11.3345 11.3334 11.3345 9.66675C11.3345 8.00008 12.6678 6.66675 14.3345 6.66675C16.0011 6.66675 17.3345 8.00008 17.3345 9.66675Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.333 11.6667C15.4376 11.6667 16.333 10.7713 16.333 9.66675C16.333 8.56218 15.4376 7.66675 14.333 7.66675C13.2284 7.66675 12.333 8.56218 12.333 9.66675C12.333 10.7713 13.2284 11.6667 14.333 11.6667Z",
    fill: "#664E27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8655 12.2342C15.3809 12.2342 15.7988 11.7566 15.7988 11.1675C15.7988 10.5784 15.3809 10.1008 14.8655 10.1008C14.35 10.1008 13.9321 10.5784 13.9321 11.1675C13.9321 11.7566 14.35 12.2342 14.8655 12.2342Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6002 10.3004C13.8948 10.3004 14.1336 10.0168 14.1336 9.66702C14.1336 9.31724 13.8948 9.03369 13.6002 9.03369C13.3057 9.03369 13.0669 9.31724 13.0669 9.66702C13.0669 10.0168 13.3057 10.3004 13.6002 10.3004Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 9.66699C8.66699 11.3337 7.33366 12.667 5.66699 12.667C4.00032 12.667 2.66699 11.3337 2.66699 9.66699C2.66699 8.00032 4.00032 6.66699 5.66699 6.66699C7.33366 6.66699 8.66699 8.00032 8.66699 9.66699Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66553 11.6667C6.7701 11.6667 7.66553 10.7713 7.66553 9.66675C7.66553 8.56218 6.7701 7.66675 5.66553 7.66675C4.56096 7.66675 3.66553 8.56218 3.66553 9.66675C3.66553 10.7713 4.56096 11.6667 5.66553 11.6667Z",
    fill: "#664E27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19994 12.2339C6.7154 12.2339 7.13327 11.7564 7.13327 11.1673C7.13327 10.5781 6.7154 10.1006 6.19994 10.1006C5.68447 10.1006 5.2666 10.5781 5.2666 11.1673C5.2666 11.7564 5.68447 12.2339 6.19994 12.2339Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93128 10.2999C5.22583 10.2999 5.46462 10.0163 5.46462 9.66654C5.46462 9.31676 5.22583 9.0332 4.93128 9.0332C4.63673 9.0332 4.39795 9.31676 4.39795 9.66654C4.39795 10.0163 4.63673 10.2999 4.93128 10.2999Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 11.3335C13.2997 13.6002 12.333 15.6668 12.333 17.3668C12.333 18.8335 13.533 20.0002 14.9997 20.0002C16.4663 20.0002 17.6663 18.8335 17.6663 17.3668C17.6663 15.6668 16.6663 13.5668 14.9997 11.3335Z",
    fill: "#65B1EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0667 6.23289C16.0001 5.33289 14.5667 4.93289 13.1667 5.19956C12.9667 5.23289 12.8001 4.53289 13.0334 4.46623C14.6334 4.16623 16.3001 4.63289 17.5334 5.66623C17.7334 5.83289 17.2001 6.36623 17.0667 6.23289ZM6.83339 5.13289C5.43339 4.89956 4.00006 5.26623 2.9334 6.16623C2.80006 6.29956 2.26673 5.76623 2.46673 5.59956C3.70006 4.53289 5.36673 4.09956 6.96673 4.39956C7.20006 4.46623 7.03339 5.16623 6.83339 5.13289Z",
    fill: "#917524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSadFace);
export default __webpack_public_path__ + "static/media/emoji-sad-face.f4b215d873d705dd88de8f18623e0f76.svg";
export { ForwardRef as ReactComponent };